import appIntegrationDetails from './app-integration-details';
import checkAcquiredApps from './check-acquired-apps';
import checkEnterpriseEntitlements from './check-enterprise-entitlements';
import checkEntitlements from './check-entitlements';
import checkIfUserIsInOrganization from './check-if-user-is-in-organization';
import createEnterpriseEntitlements from './create-enterprise-entitlements';
import createFreeEntitlements from './create-free-entitlements';
import downloadPlugin from './download-plugin';
import generateUniqueId from './generate-unique-id';
import getECAppDetails from './get-ecdetails';
import getPreviewDetails from './get-preview-details';
import getPublisherApps from './get-publisher-apps';
import getPublisherIntegrations from './get-publisher-integrations';
import addReply from './reviews/add-reply';
import addReview from './reviews/add-review';
import deleteReply from './reviews/delete-reply';
import deleteReview from './reviews/delete-review';
import editReply from './reviews/edit-reply';
import editReview from './reviews/edit-review';
import getMyReview from './reviews/get-my-review';
import getReplies from './reviews/get-replies';
import getReviews from './reviews/get-reviews';
import getRnrEndpoints from './reviews/get-rnr-endpoints';
import sendEmailToPublisher from './send-email-to-publisher';
import sendReportAbuse from './send-report-abuse';
import generateUniqueIdV2 from './generate-unique-id-v2'
import { arsEndpointSettings, reviewSettings, rnrHeadEndpointSettings, settings } from './setup';

export default {
  getPublisherApps,
  getECAppDetails,
  sendEmailToPublisher,
  settings,
  arsEndpointSettings,
  appIntegrationDetails,
  getPublisherIntegrations,
  reviewSettings,
  getReviews,
  getReplies,
  getMyReview,
  addReply,
  addReview,
  editReply,
  editReview,
  deleteReply,
  deleteReview,
  sendReportAbuse,
  checkAcquiredApps,
  checkEntitlements,
  createFreeEntitlements,
  generateUniqueId,
  generateUniqueIdV2,
  downloadPlugin,
  getPreviewDetails,
  checkIfUserIsInOrganization,
  rnrHeadEndpointSettings,
  getRnrEndpoints,
  checkEnterpriseEntitlements,
  createEnterpriseEntitlements,
};
